import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { validate as isValidUUID } from 'uuid';

import { backendApiSignGroupsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

export const useSignGroupQuery = () => {
  const paramsSignGroupId = useParams({
    strict: false,
    select: (params) => params.signGroupId,
  });

  return useQuery({
    ...backendApiSignGroupsFindOneOptions({ path: { signGroupId: paramsSignGroupId as string } }),
    enabled: isValidUUID(paramsSignGroupId),
  });
};
